import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopuneonewaycab() {



const cardData = {
  keyword: " Mumbai to Pune One Way Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune one way cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Pune convenient and stress-free. With our affordable one-way cab option, travelers only pay for a single trip without return charges. We offer flexible booking options, transparent pricing with no hidden charges, and a fleet of air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Pune one way cab travel.",

topPlaces: [
 {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of the oldest heritage sites in Pune offering panoramic views of the city. Travelers arriving from Mumbai by cab often climb the hill to enjoy scenic beauty and visit the historic temples."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular getaway near Pune known for its serene water views and surrounding hills. Travelers from Mumbai often visit this relaxing spot for photography and peaceful sunsets."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a beautifully designed Japanese-style garden. Visitors traveling from Mumbai by cab can enjoy its calm atmosphere, walking paths, and lush greenery."
  },
   {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Travelers using a Mumbai to Pune one way cab often visit this landmark to explore its grand gates, historical ruins, and cultural significance."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks associated with India’s freedom movement and Mahatma Gandhi. Visitors traveling from Mumbai by cab can explore its elegant architecture, peaceful gardens, and museum."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fortress located on the outskirts of Pune, known for its scenic views and Maratha history. Travelers arriving from Mumbai by cab often include this destination for trekking and enjoying breathtaking landscapes."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune dedicated to Lord Ganesha. Visitors traveling from Mumbai by cab frequently stop here to seek blessings and experience the spiritual atmosphere."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva located in the heart of Pune. Travelers using a Mumbai to Pune one way cab can visit this peaceful historical site known for its unique architecture."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a remarkable collection of Indian artifacts including sculptures, musical instruments, and decorative items. Visitors from Mumbai can explore Pune’s rich cultural heritage through this museum."
  },
  
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace associated with the childhood of Chhatrapati Shivaji Maharaj. Travelers using a Mumbai to Pune one way cab can visit this important landmark to learn about Pune’s rich Maratha history."
  }
],



services: [
{
name: "Mumbai Pune Cab One Way",
description: "Mumbai Pune cab one way service offers convenient single-trip transportation between Mumbai and Pune without return charges. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel via the Mumbai–Pune Expressway. Professional drivers provide punctual pickup services from homes, offices, railway stations, and airport terminals."
},
{
name: "One Way Taxi Mumbai to Pune",
description: "One way taxi Mumbai to Pune provides reliable intercity travel with comfortable vehicles and experienced drivers. The service is ideal for passengers looking for cost-effective one-way transportation between the two cities."
},
{
name: "Mumbai Pune One Way Drop",
description: "Mumbai Pune one way drop service provides convenient drop-only transportation between Mumbai and Pune. Travelers can choose from sedan, Ertiga, or Innova vehicles depending on comfort and group size."
},
{
name: "One Way Cab Pune to Mumbai Airport",
description: "One way cab Pune to Mumbai Airport offers reliable airport transfers from Pune to Chhatrapati Shivaji Maharaj International Airport. Comfortable vehicles ensure safe and timely travel for passengers catching flights."
},
{
name: "One Way Mumbai to Pune",
description: "One way Mumbai to Pune cab service provides economical single-trip transportation between Mumbai and Pune. Professional drivers ensure safe and smooth expressway journeys."
},
{
name: "Pune to Mumbai Airport One Way Cab",
description: "Pune to Mumbai Airport one way cab service offers convenient airport drop transportation for travelers heading from Pune to Mumbai Airport terminals."
},
{
name: "Mumbai Pune One Way Innova Taxi",
description: "Mumbai Pune one way Innova taxi service provides premium SUV transportation for comfortable and spacious highway journeys between Mumbai and Pune."
},
{
name: "Mumbai Pune One Way Sedan Taxi",
description: "Mumbai Pune one way sedan taxi service offers economical intercity transportation using vehicles like Swift Dzire and Etios suitable for individuals and small families."
},
{
name: "Mumbai Pune One Way Drop",
description: "Mumbai Pune one way drop cab service provides convenient door-to-door transportation between the two cities with comfortable vehicles and experienced drivers."
},
{
name: "Mumbai to Pune One Way Ertiga Drop",
description: "Mumbai to Pune one way Ertiga drop service offers comfortable 7-seater SUV transportation suitable for families and small groups traveling between Mumbai and Pune."
},
{
name: "Mumbai to Pune One Way Cab",
description: "Mumbai to Pune one way cab service offers convenient single-trip transportation with flexible booking options and comfortable vehicles."
},
{
name: "Mumbai Pune Cab One Way",
description: "Mumbai Pune cab one way travel provides reliable transportation between the two cities with experienced drivers and well-maintained vehicles."
},
{
name: "One Way Cab Pune to Mumbai",
description: "One way cab Pune to Mumbai service offers convenient intercity travel with comfortable vehicles suitable for highway journeys."
},
{
name: "Pune to Mumbai Taxi One Way",
description: "Pune to Mumbai taxi one way service provides economical transportation between Pune and Mumbai without return charges."
},
{
name: "Pune Mumbai Cab One Way",
description: "Pune Mumbai cab one way service offers reliable single-trip transportation with comfortable vehicles and experienced drivers."
},
{
name: "One Way Taxi Mumbai to Pune",
description: "One way taxi Mumbai to Pune provides convenient intercity travel with affordable pricing and comfortable vehicles."
},
{
name: "One Way Cab Pune to Mumbai Airport",
description: "One way cab Pune to Mumbai Airport offers dependable airport transfer services for travelers heading from Pune to Mumbai Airport."
},
{
name: "One Way Mumbai to Pune",
description: "One way Mumbai to Pune cab service provides flexible and convenient transportation between the two cities."
},
{
name: "One Way Pune to Mumbai",
description: "One way Pune to Mumbai taxi service offers reliable intercity transportation with comfortable vehicles suitable for long-distance travel."
},
{
name: "Mumbai One Way Cab",
description: "Mumbai one way cab service provides convenient transportation from Mumbai to nearby cities like Pune with affordable pricing and professional drivers."
}
],

tableData: [
["Mumbai Pune Cab One Way","One Way Taxi Mumbai to Pune"],
["Mumbai Pune One Way Drop","One Way Cab Pune to Mumbai Airport"],
["One Way Mumbai to Pune","Pune to Mumbai Airport One Way Cab"],
["Mumbai Pune One Way Innova Taxi","Mumbai Pune One Way Sedan Taxi"],
["Mumbai Pune One Way Drop","Mumbai to Pune One Way Ertiga Drop"],
["Mumbai to Pune One Way Cab","Mumbai Pune Cab One Way"],
["One Way Cab Pune to Mumbai","Pune to Mumbai Taxi One Way"],
["Pune Mumbai Cab One Way","One Way Taxi Mumbai to Pune"],
["One Way Cab Pune to Mumbai Airport","One Way Mumbai to Pune"],
["One Way Pune to Mumbai","Mumbai One Way Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Mumbai to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely one-way intercity travel."
  },
  {
    WhyChooseheading: "Affordable One Way Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai to Pune one way cab bookings. Customers only pay for the distance travelled without return charges, making it a cost-effective travel option."
  },
  {
    WhyChooseheading: "24/7 One Way Cab Availability",
    WhyChoosedescription: "Our Mumbai to Pune one way cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable and relaxing long-distance travel experience."
  },
  {
    WhyChooseheading: "Direct One Way Travel Option",
    WhyChoosedescription: "Velocity Cabs provides direct one-way cab services from Mumbai to Pune without unnecessary stops, ensuring faster and more convenient travel for passengers."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, airports, railway stations, and residential areas across Mumbai including Andheri, Bandra, Borivali, Dadar, Thane, and Navi Mumbai."
  },
  {
    WhyChooseheading: "Trusted One Way Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pune one way cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pune one way cab service?", answer: "Yes, Velocity Cabs provides reliable one-way cab services from Mumbai to Pune with professional drivers and comfortable vehicles." },
  { question: "What is the distance between Mumbai and Pune?", answer: "The road distance between Mumbai and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Mumbai to Pune one way cab service available 24 hours?", answer: "Yes, our one-way cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mumbai to Pune one way travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one way cab from Mumbai Airport to Pune?", answer: "Yes, we provide one way cab services from Mumbai Airport and other locations across Mumbai to Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, airports, and railway stations across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the one way cab online?", answer: "Yes, customers can easily book Mumbai to Pune one way cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, Velocity Cabs provides drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very convenient one way cab service from Mumbai to Pune. The booking process was simple, and the ride was smooth, punctual, and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Mumbai to Pune one way cab service was reliable and well-organized. The vehicle was clean, the driver was professional, and the journey felt safe and stress-free.",
    rating: 5
  }
];




































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune One Way Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Mumbai to Pune one way cab service with affordable fares and professional drivers. Book one way taxis including Innova, Ertiga, Innova Crysta, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai to Pune One Way Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune one way cab with Velocity Cabs. Affordable taxis including Innova, Ertiga, Innova Crysta & Sedan for airport transfers, city-to-city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopuneonewaycab;